import { Subsidiary } from '@coolblue-development/constants';
import { FlagBE, FlagDE, FlagNL } from '@coolblue-development/icons';

export const flagMap = {
  [Subsidiary.BE]: <FlagBE />,
  [Subsidiary.DE]: <FlagDE />,
  [Subsidiary.NL]: <FlagNL />
};
